var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b0071c056b10c6554a80c95be07d70bd.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d3029801bca6fb343e57adf2c4d352a0.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d4fda97ada8059705ac9d5b8a4ed71c7.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    